module.exports = __webpack_public_path__ + "img/Coursera.25ef7d11.svg";